

export default function Error({ message }) {
    return (
        <div className="text-lava font-semibold leading-snug">
            { message }
        </div>
    );
}